import { render, staticRenderFns } from "./DeliveryDetail.vue?vue&type=template&id=38701108&"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetail.vue?vue&type=style&index=0&id=38701108&prod&lang=scss&"
import style1 from "./DeliveryDetail.vue?vue&type=style&index=1&id=38701108&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports